import {
  addAcctService,
  getAcctDetailService,
  getAllAccountService,
  getAttrInfoService,
  getBillFormatService,
  getBillingCycleTypeService,
  getLanguageListService,
  getRootAcctService,
  modifyAcctService,
} from '@/pages/AccountMgr/services';
import { useRequest } from 'ahooks';
import { useState } from 'react';

export default function AccountMgrModel() {
  const [selectedAccount, setSelectedAccount] = useState<any>({}); // 用于modify操作后刷新树接口
  const [action, setAction] = useState<string>(''); // 记录操作按钮动作

  const { loading: queryRootLoading, runAsync: queryRootList } = useRequest(
    getRootAcctService,
    {
      manual: true,
    },
  );

  const {
    loading: queryAllAccLoading,
    data: allAccountList,
    run: queryAllAccountList,
  } = useRequest(getAllAccountService, {
    manual: true,
  });

  const {
    loading: queryAcctDetailLoading,
    data: acctDetail,
    run: queryAcctDetailInfo,
    mutate: resetAcctDetail,
  } = useRequest(getAcctDetailService, {
    manual: true,
  });

  const { runAsync: queryBillingCycleType } = useRequest(
    getBillingCycleTypeService,
    {
      manual: true,
    },
  );

  const { data: attrList, run: queryAttrInfo } = useRequest(
    getAttrInfoService,
    {
      manual: true,
    },
  );

  const { data: billFormatList, run: queryBillFormat } = useRequest(
    getBillFormatService,
    {
      manual: true,
    },
  );

  const { data: languageList, run: queryLanguageList } = useRequest(
    getLanguageListService,
    {
      manual: true,
    },
  );

  const { runAsync: addAcct } = useRequest(addAcctService, {
    manual: true,
  });

  const { runAsync: modifyAcct } = useRequest(modifyAcctService, {
    manual: true,
  });

  return {
    addAcct,
    modifyAcct,
    queryAttrInfo,
    queryBillFormat,
    queryRootList,
    queryLanguageList,
    queryAllAccountList,
    queryAcctDetailInfo,
    queryBillingCycleType,
    setAction,
    resetAcctDetail,
    action,
    attrList,
    languageList,
    billFormatList,
    allAccountList,
    queryRootLoading: queryRootLoading,
    queryAllAccLoading,
    queryAcctDetailLoading,
    acctDetail: acctDetail?.bcareAcctInfoDto,
    selectedAccount,
    setSelectedAccount,
  };
}
